import van from "vanjs-core";
import {Footer} from "./page2/footer";
import {MainContent} from "./page2/main-content";
import {Header} from "./page2/header";

const {div} = van.tags;

// 2. obrazovka
export const Page2 = () => {
    return div({class: 'bg-primary w-100 d-flex flex-column min-h-100-v'},
        Header,
        MainContent,
        Footer
    );
};